import { useState } from 'react';
import { fetchWithAuth } from '../Utils/fetchWithAuth'; 

export default function usePost() {
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);

  const postData = async (url, dataToPost) => {
    setLoading(true);
    setError(null);
    setResponseData(null);

    try {
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToPost),
      });

      if (!response.ok) {
        throw new Error(`Errore nella richiesta: ${response.status}`);
      }

      const json = await response.json();
      setResponseData(json);
      return json;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { responseData, loading, error, postData };
}
